/**
 * @author yan st
 * @date 2022-08-30 13:51
 * @Description:
 */

export const massesRouter = [
  {
    path: '',
    redirect: 'index'
  },
  {
    path: 'index',
    meta: {
      title: '首页',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/masses/pages/index'),
  },
  {
    path: 'publicizeList',
    meta: {
      title: '宣传信息',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/masses/pages/publicizeList'),
  },
  {
    path: 'policyList',
    meta: {
      title: '政策法规',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/masses/pages/policyList'),
  },
  {
    path: 'technologyList',
    meta: {
      title: '科技专栏',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/masses/pages/technologyList'),
  },
  {
    path: 'orgList',
    meta: {
      title: '持证教培机构名单',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/masses/pages/orgList'),
  },
  {
    path: 'detail',
    meta: {
      title: '详情',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/masses/pages/detail'),
  }
]




export default massesRouter
